import { Link } from "react-router-dom";
import Spinner from "../../components/ui/Spinner";

export const authInputClass =
  "h-[48px] rounded bg-white/20 px-4 text-sm font-thin focus:outline-none focus:ring-2 focus:ring-brand";

/**
 * Shared chrome for all four auth screens. Login, LoginVerify, SignUp and
 * SignUpVerify each carried their own copy of this markup plus a 40-line
 * inline SVG spinner.
 */
const AuthShell = ({
  title,
  altLabel,
  altTo,
  errors = [],
  loading,
  submitLabel,
  onSubmit,
  children,
}) => (
  <div className="mt-[5rem] h-full w-full bg-[#111312]/30 pt-10 sm:pt-12">
    <div className="z-10 m-auto w-[18rem] sm:w-[28rem] lg:w-[32rem]">
      {altTo && (
        <div className="flex flex-row justify-between">
          <Link to="/">
            <h2> نوساز </h2>
          </Link>
          <Link to={altTo}>
            <button
              type="button"
              className="rounded border-none bg-white px-6 py-3 text-xs text-black transition hover:bg-brand hover:text-white"
            >
              {altLabel}
            </button>
          </Link>
        </div>
      )}

      <form
        onSubmit={onSubmit}
        className="my-[8rem] flex flex-col rounded-xl sm:mt-12 sm:bg-[#222327] sm:px-12 sm:py-14"
      >
        <h3 className="text-xl font-bold sm:mb-8">{title}</h3>

        {errors.filter(Boolean).map((message) => (
          <p key={message} role="alert" className="my-3 rounded bg-red-600 p-3">
            {message}
          </p>
        ))}

        <div className="flex flex-col gap-6 py-6">{children}</div>

        {loading ? (
          <Spinner size="sm" className="mt-10 sm:mt-14" />
        ) : (
          <button
            type="submit"
            className="mt-10 h-[38px] cursor-pointer rounded bg-[#9b9b9bda] text-sm font-thin transition hover:bg-brand focus:outline-none sm:mt-14"
          >
            {submitLabel}
          </button>
        )}
      </form>
    </div>
  </div>
);

export default AuthShell;
